import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import ContentSidebar from "./components/ContentSidebar";
import LinkedInSection from "./components/LinkedInSection";
import NewsSection from "./components/NewsSection";
import NewsLetter from "./components/NewsLetter";
import Redirection from "./components/Redirection";
import { fetchToken } from "../../../Auth";
import axios from "axios";
import { adminURL } from "../../../global";
import { checkRoute } from '../../../services/auth';

const Shorts = () => {
  const navigate = useNavigate();
  const [activeSection, setActiveSection] = useState("social");
  const [privileges, setPrivileges] = useState({
    superAdmin: false,
    createPrivilege: false,
    livePrivilege: false,
    editPrivilege: false,
    deletePrivilege: false,
  });
  const getPrivileges = async () => {
    try {
      const response = await axios.get('/get_privileges', {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${fetchToken("nuprice_access_token")}`,
        },
      });
  
      if (response.status === 200) {
        // If response.data is undefined, set all privileges to false
        if (response.data === undefined) {
          setPrivileges({
            superAdmin: false,
            createPrivilege: false,
            livePrivilege: false,
            editPrivilege: false,
            deletePrivilege: false,
          });
        } else {
          // If response.data exists, set privileges based on the data
          setPrivileges({
            superAdmin: Boolean(response.data["superAdmin"]),
            createPrivilege: Boolean(response.data["6"]["create"]),
            livePrivilege: Boolean(response.data["6"]["makeLive"]),
            editPrivilege: Boolean(response.data["6"]["edit"]),
            deletePrivilege: Boolean(response.data["6"]["delete"]),
          });
        }
        // setFetch(true);
      }
    } catch (err) {
      console.error("Error", err);
      if (err.response?.status === 401) {
        navigate(`/niyantran-panel/${adminURL}/login`);
      }
    }
  };

  
  useEffect(() => {
    const verifyRoute = async () => {
      try {
        const response = await checkRoute(navigate, adminURL); 
        console.log('Route check response:', response);
      } catch (err) {
        console.log('Route check failed:', err);
      }
    };

    verifyRoute();
  }, [navigate, adminURL]);


  useEffect(() => {
    getPrivileges();
  }, []);
  return (
    <Box sx={{ display: "flex", height: "100vh" }}>
      <ContentSidebar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <Box
        component="main"
        sx={{ flexGrow: 1, py: 3, px: 2, overflowY: "auto" }}
      >
        {activeSection === "social" && <LinkedInSection  privileges={privileges}/>}
        {activeSection === "news" && <NewsSection privileges={privileges} />}
        {activeSection === "newsLetter" && <NewsLetter privileges={privileges} />}
        {activeSection === "redirection" && <Redirection privileges={privileges} />}
      </Box>
    </Box>
  );
};

export default Shorts;
